<template>
    <div>
        <van-nav-bar :title="$route.meta.title" @click-left="$refs.userTabbar.show()">
            <template #left>
                <van-icon name="wap-nav" size="18" />
            </template>
            <template #right>
                <van-icon class-prefix="icon" name="edit-square" size="18" color="#1677ff" @click="showPopup = true" />
            </template>
        </van-nav-bar>

        <van-list
            :offset="50"
            v-model="listLoading"
            :finished="listFinished"
            finished-text="没有更多了"
            @load="onLoad"
            :error.sync="error"
            error-text="加载,点击重新加载"
        >
            <div class="intercession-item" v-for="item in intercessions.data" :key="item.id">
                <div class="intercessor">
                    <span>{{ item.intercessor }}</span>
                    <van-tag plain :type="typeColors[item.status]">{{ status[item.status] }}</van-tag>
                </div>
                <div class="time">
                    <span>{{ item.created_at }}</span>
                    <span class="over-text" v-if="item.status === 'review_success'" @click="showActionSheet(item)"
                        >结束代祷</span
                    >
                </div>
                <span class="content">{{ item.content }}</span>
            </div>
        </van-list>

        <user-tabbar ref="userTabbar" />
        <intercession-popup :showPopup.sync="showPopup" />
        <van-action-sheet
            @select="finishedIntercession"
            round
            v-model="finishedCheck"
            :actions="actions"
            cancel-text="关闭"
            @cancel="finishedCheck = false"
            close-on-click-overlay
        ></van-action-sheet>
    </div>
</template>

<script>
import UserTabbar from '@/view/home/UserTabbar.vue'
import IntercessionPopup from '@/view/intercession/IntercessionPopup'
import { getUserIntercessions, finishedUserIntercession } from '@/api/common'

export default {
    name: 'UserIntercession',
    components: { UserTabbar, IntercessionPopup },
    data() {
        return {
            showPopup: false,
            listLoading: false,
            listFinished: false,
            error: false,
            intercessions: {
                meta: {
                    current_page: 0,
                    last_page: 0,
                },
                data: [],
            },
            typeColors: {
                waiting_review: 'warning',
                review_success: 'success',
                review_failed: 'danger',
                admin_finished: 'primary',
                user_finished: 'primary',
            },
            status: {
                waiting_review: '待审核',
                review_success: '审核通过',
                review_failed: '审核未通过',
                admin_finished: '已结束',
                user_finished: '已结束',
            },
            finishedIntercessionId: null,
            finishedCheck: false,
            actions: [{ name: '确认' }],
        }
    },
    methods: {
        getUserIntercessions() {
            getUserIntercessions({
                pageSize: 10,
                page: this.intercessions.meta.current_page + 1,
            })
                .then((res) => {
                    res.data.unshift(...this.intercessions.data)
                    this.intercessions = res
                    this.listLoading = false
                    // 数据全部加载完成
                    if (res.meta.current_page === res.meta.last_page) {
                        this.listFinished = true
                    }
                })
                .catch(() => {
                    this.error = true
                })
        },
        onLoad() {
            this.getUserIntercessions()
        },
        showActionSheet(item) {
            this.finishedIntercessionId = item.id
            this.finishedCheck = true
        },
        finishedIntercession() {
            finishedUserIntercession(this.finishedIntercessionId).then(() => {
                this.getUserIntercessions()
            })
            this.finishedCheck = false
        },
    },
}
</script>

<style lang="less" scoped>
.intercession-item {
    position: relative;
    padding: 15px;
    background: white;

    &::after {
        content: '';
        position: absolute;
        left: 15px;
        bottom: 0;
        width: calc(100% - 30px);
        height: 0.6px;
        background: @gray-3;
    }

    .intercessor,
    .time {
        display: flex;
        justify-content: space-between;
    }

    .intercessor {
        margin-bottom: 10px;
    }

    .time,
    .content {
        color: @grey;
        font-size: @small-font-size;
    }
}

.van-tag {
    padding: 5px;
    border-radius: @medium-border-radius;
}

.over-text {
    color: @blue;
}
</style>
